var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.99988,
    y: 8,
    width: 7,
    height: 7,
    rx: 1.33333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9999,
    y: 8,
    width: 7,
    height: 7,
    rx: 1.33333
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9999,
    y: 8,
    width: 7,
    height: 7,
    rx: 1.33333
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.99988,
    y: 17,
    width: 7,
    height: 7,
    rx: 1.33333
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9999,
    y: 17,
    width: 7,
    height: 7,
    rx: 1.33333
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9999,
    y: 17,
    width: 7,
    height: 7,
    rx: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardModeIcon);
export default __webpack_public_path__ + "static/media/card_mode_icon.3d93a86a42d8472b270ba2957309c3b1.svg";
export { ForwardRef as ReactComponent };